import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import './Dropdown.css';
import classnames from 'classnames';
import { updateDefaultsList } from 'redux/actions';
import { PerfectScrollbar } from 'components/shared/ReactPerfectScrollbar';
import { IconLoader } from 'common/IconLoader';
import RadioButton from 'components/shared/RadioButton/RadioButton';
import KpiSearchBar from '../SearchBar/KpiSearchBar';
import KpiDetailsCard from '../KpiDetailsCard/KpiDetailsCard';

class Dropdown extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showMenu: false,
      selectedText: '',
      isSelected: false,
      isChecked: false,
      isButtonHovered: false,
      query: '',
      hoverItem: null
    };
  }

  updateSelection = (item, id = null, index) => {
    if (this.props.kpiSearch) {
      this.setState({ query: '' });
    }
    if (this.props.isAlarmSort) {
      this.props.sortOnClick(item);
    }

    if (!this.props.isRadioButton) {
      this.toggleMenu();
    }

    this.setState({
      selectedText: item,
      isSelected: true
    });
    this.props.selectItem && this.props.selectItem(item, id, index);
    this.props.sendId && this.props.sendId(id);
  };

  toggleMenu = () => {
    this.setState({
      showMenu: !this.state.showMenu
    });

    if (this.props.customClose && this.state.showMenu === false) {
      this.props.customClose();
    }
  };

  componentDidMount() {
    if (this.props.title) {
      this.setState({
        selectedText: this.props.title
      });
    }
    document.addEventListener('mousedown', this.handleClick, false);
  }

  componentDidUpdate() {
    if (!this.props.isActive) {
      this.setState({
        selectedText: this.state.selectedText ? this.state.selectedText : this.props.title,
        isSelected: false
      });
    }

    if (this.props.title && this.props.title !== this.state.selectedText) {
      this.setState({
        selectedText: this.props.title
      });
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClick, false);
  }

  handleClick = (e) => {
    if (this.state.showMenu && !this.node.contains(e.target)) {
      this.setState({
        showMenu: false,
        query: ''
      });

      if (this.props.setCustomMode) {
        this.props.setCustomMode(null);
      }
    }
  };

  handleContinueOnClick = (e) => {
    if (this.state.showMenu) {
      this.setState({
        showMenu: false
      });
    }
  };

  mapDispatchToProps = (dispatch) => {
    return {
      updateDefaultsList: () => dispatch(updateDefaultsList())
    };
  };

  handleQueryOnChange = (value) => {
    this.setState({ query: value });
  };

  filteredOptions = (options) => {
    if (!options) return [];
    if (this.state.query === '' || !this.props.kpiSearch) {
      return options.sort((a, b) => a.label.localeCompare(b.label));
    }

    // for Kpi search only, option will be a list of object instead of strings
    return options
      .filter((option) => option.label.toLowerCase().includes(this.state.query.toLowerCase()))
      .sort((a, b) => a.label.localeCompare(b.label));
  };

  getOptionLabel = (item) => item?.label ?? item;

  render() {
    const menuOpen = this.state.showMenu ? 'shown' : 'hidden';

    let keyAssigner = 1;

    let contentBoxStyle = {
      ...(this.props.overflowHeight && { height: this.props.overflowHeight })
    };

    let displayHeight = this.props.showItems ? { height: this.props.showItems * 32 + 16 } : null;

    return (
      <div
        className={classnames('dropdownContainer', this.props.className, { noArrow: this.props.hideArrow })}
        ref={(node) => (this.node = node)}
      >
        <button
          type="button"
          role={this.props.role}
          aria-disabled={this.props.disabled}
          data-testid={this.props['data-testid']}
          className={classnames(
            'dropdownButton',
            { pickedFilter: this.props.isActive },
            { noArrow1: this.props.hideArrow },
            { whiteButton: this.props.colorMode === 'white' },
            { clearButton: this.props.colorMode === 'clear' },
            { dropdownButton_alarmSort: this.props.isAlarmSort },
            { dropdownButton_alarmSort_active: this.props.isAlarmSort && this.state.showMenu },
            { dropdownButton_iconOnly: this.props.isIconButton },
            { dropdownButton_radioButton: this.props.isRadioButton }
          )}
          onClick={this.toggleMenu}
          onMouseEnter={() => this.setState({ isButtonHovered: true })}
          onMouseLeave={() =>
            this.setState({ isButtonHovered: false, ...(this.props.mouseover && { showMenu: false }) })
          }
          onMouseOver={() => this.props.mouseover && this.setState({ showMenu: true })}
        >
          {this.props.isAlarmSort && (
            <img
              src={
                this.state.showMenu || this.state.isButtonHovered ? IconLoader.icon_sort_hover : IconLoader.icon_sort
              }
              alt={''}
            />
          )}
          <div
            className={classnames(
              { dropdownButtonContent: true },
              { dropdownButtonContent_alarmSort: this.props.isAlarmSort },
              { dropdownButtonContent_iconOnly: this.props.isIconButton },
              { dropdownButtonContent_radioButton: this.props.isRadioButton }
            )}
          >
            {!this.props.isRadioButton && !this.props.isIconButton && this.props.customButtonContent == null && (
              <span
                className={classnames(
                  { dropdownButtonContentText: true },
                  { dropdownButtonContentText_AlarmsHistory: this.props.alarmsHistory || this.props.alarmsHistoryDate },
                  { dropdownButtonContentTextOverflow: this.props.overflowEllipsis }
                )}
              >
                {this.state.selectedText}
              </span>
            )}
            {this.props.customButtonContent && (
              <div className="dropdownButtonCustomContent">{this.props.customButtonContent}</div>
            )}
            {!this.props.hideArrow && (
              <img
                className={classnames('ddArrowRight', { iconTurn: this.state.showMenu })}
                src={IconLoader.icon_dropdown_arrow}
                alt={''}
              />
            )}
          </div>
        </button>
        {!this.props.disabled && this.state.showMenu && (
          <div
            style={contentBoxStyle}
            className={classnames({
              [menuOpen]: true,
              calendarMode: this.props.customMode === 'CALENDAR',
              dropdownContent: !this.props.alarmsHistory && !this.props.alarmsHistoryDate,
              dropdownContentUpwards: this.props.contentUpwards,
              dropdownContentAlarmsHistory: this.props.alarmsHistory,
              dropdownContentAlarmsHistoryDate: this.props.alarmsHistoryDate,
              dropdownContent_AlarmSort: this.props.isAlarmSort,
              dropdownContent_RadioButton: this.props.isRadioButton,
              dropdownContent_searchKpi: this.props.kpiSearch
            })}
          >
            <div
              className={classnames({
                dropdownContent_RadioButton: this.props.isRadioButton
              })}
            >
              {this.props.isFetching && (
                <div className="fetchingDDSection">
                  <img
                    className="fetchingDDSection_LoadingIcon Global_Spinner"
                    src={IconLoader.icon_spinner_small}
                    alt={'loading icon'}
                  />
                </div>
              )}
              {!this.props.customMode && !this.props.isFetching && (
                <div className="dropdownPrimaryContent">
                  {this.props.showItems != null && !this.props.isRadioButton && (
                    <ul role="menu" className={classnames({ dropdownMenu: true })} style={displayHeight}>
                      {this.props.kpiSearch && <KpiSearchBar onChange={this.handleQueryOnChange} />}
                      <PerfectScrollbar>
                        {this.filteredOptions(this.props.data).map((item, index) => (
                          <div key={index}>
                            <li
                              role="menuitem"
                              key={keyAssigner++}
                              onMouseOver={() => {
                                if (this.props.kpiSearch) {
                                  this.setState({ hoverItem: item });
                                }
                              }}
                              onMouseLeave={() => {
                                if (this.props.kpiSearch) {
                                  this.setState({ hoverItem: null });
                                }
                              }}
                              onClick={() =>
                                this.updateSelection(
                                  this.getOptionLabel(item),
                                  this.props.ids && this.props.ids[index],
                                  index
                                )
                              }
                            >
                              {this.getOptionLabel(item)}
                            </li>
                          </div>
                        ))}
                      </PerfectScrollbar>
                      {this.props.kpiSearch && this.state.hoverItem?.metadata != null && (
                        <div className="KpiDetails_DropdownContainer">
                          <KpiDetailsCard metadata={this.state.hoverItem.metadata} />
                        </div>
                      )}
                    </ul>
                  )}
                  {this.props.showItems != null && this.props.isRadioButton && (
                    <ul className={classnames({ dropdownMenu: true })} style={displayHeight}>
                      <PerfectScrollbar>
                        {this.props.data.map((item, index) => (
                          <li
                            key={keyAssigner++}
                            onClick={() => this.updateSelection(item, this.props.ids && this.props.ids[index], index)}
                          >
                            <RadioButton
                              isChecked={
                                this.state.selectedText ? this.props.selectItem : this.props.isChecked === item
                              }
                              uniqueID={'uniqueID' + index.toString()}
                              text={item}
                              selectItem={this.props.selectItem}
                              sendItem={item}
                            />
                          </li>
                        ))}
                      </PerfectScrollbar>
                    </ul>
                  )}
                  {this.props.showItems == null && (
                    <ul
                      role="menu"
                      aria-label="Select"
                      className={classnames({ dropdownMenu: true }, { dropdownMenu_alarmSort: this.props.isAlarmSort })}
                    >
                      {this.props.data.map((item, index) => (
                        <li
                          role="menuitem"
                          key={keyAssigner++}
                          onClick={() => this.updateSelection(item, this.props.ids && this.props.ids[index], index)}
                        >
                          {item}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              )}
              {this.props.customSection && !this.props.isFetching && (
                <div className="customDDSection">{this.props.customSection}</div>
              )}
            </div>
            {this.props.isRadioButton && (
              <div className="dropdown_FinishButtons">
                <button
                  type="button"
                  className="dropdown_FinishButtons_CancelButton"
                  onClick={() => {
                    this.setState({
                      showMenu: false
                    });
                  }}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="dropdown_FinishButtons_ContinueButton"
                  onClick={(event) => {
                    if (this.state.showMenu) {
                      this.setState({
                        showMenu: false
                      });
                    }
                    this.props.defaultSwVersionId &&
                      this.props.dispatch(
                        updateDefaultsList(
                          this.state.selectedText,
                          this.props.sendIndex(),
                          this.props.defaultSwVersionId
                        )
                      );
                    event.preventDefault();
                  }}
                >
                  Set as default
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default connect(undefined, undefined, undefined, { forwardRef: true })(Dropdown);
